import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "payout-qr d-inline-flex flex-column align-items-start gap-2" }
const _hoisted_2 = { class: "d-flex align-items-center gap-xs" }
const _hoisted_3 = ["href"]
const _hoisted_4 = {
  key: 1,
  class: "text-secondary text-wrap"
}
const _hoisted_5 = {
  key: 2,
  class: "text-secondary text-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_qrcode = _resolveComponent("vue-qrcode")!
  const _component_copy_button = _resolveComponent("copy-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.compact)
      ? (_openBlock(), _createBlock(_component_vue_qrcode, {
          key: 0,
          value: _ctx.link,
          tag: "svg",
          class: "payout-qr__qr",
          style: {"width":"100%","border-radius":"10px"},
          options: { width: '200px' }
        }, null, 8, ["value"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: _ctx.link,
        target: "_blank",
        rel: "noopener noreferrer"
      }, _toDisplayString(_ctx.helper.trans('labels.payout_qr_open_link')), 9, _hoisted_3),
      _createVNode(_component_copy_button, { value: _ctx.link }, null, 8, ["value"])
    ]),
    (!_ctx.compact)
      ? (_openBlock(), _createElementBlock("small", _hoisted_4, _toDisplayString(_ctx.helper.trans('labels.payout_qr_pay_by_qr_only')), 1))
      : (_openBlock(), _createElementBlock("small", _hoisted_5, _toDisplayString(_ctx.helper.trans('labels.payout_qr_short')), 1))
  ]))
}